export {
	slideAndFade,
	fade,
	scaleAndFade,
	dialogSlideUpAndFade,
	dialogFade,
} from '../animations/presets';
export type { TAnimationPreset } from '../animations/types';
